// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"763":"5427a596","1770":"8c83085f","3102":"607e982b","8802":"3acc225c"}[chunkId] + ".chunk.css";
};